import { AppTheme } from '../../../../theme/useTheme';
import { makeStyles } from '@mui/styles';

export const useStyles = makeStyles((theme: AppTheme) => ({
  heading: {
    paddingTop: theme.spacing(3),
    paddingBottom: theme.spacing(2),
    paddingLeft: theme.spacing(2),
    paddingRight: theme.spacing(1),
    position: 'sticky',
    top: 0,
    alignItems: 'center',
    zIndex: 1,
    backgroundColor: theme.palette.background.paper,
  },
  backButton: {
    padding: 0,
    transform: 'rotate(180deg)',
  },
  paginationContainer: {
    position: 'fixed',
    bottom: 0,
    right: 0,
    left: 0,
  },
}));
